import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { cn } from "@/shared/lib/utils";
import styles from "./ScrollRow.module.scss";
/**
 * Горизонтальная лента блоков — «слайдер» без библиотек (каруселей в проекте
 * нет, а новые зависимости заводить нельзя). Тот же приём, что у таб-бара
 * публичной страницы песни: `overflow-x: auto` + скрытый скроллбар, листается
 * пальцем/трекпадом, на широком экране просто стоит в ряд.
 *
 * Прямые дети не сжимаются и липнут к краю при подкрутке — карточке достаточно
 * задать собственную ширину.
 */
export const ScrollRow = ({ className, children, ...rest }) => (_jsx("div", { className: cn(styles.row, className), ...rest, children: children }));
